import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BillingRunAction } from "actions";
import { getLivestockSaleId } from "lib/navigation";

// state.d.ts's StateSlice<BillingRun> doesn't declare isEnabled - it's an
// extra field extraBillingRunReducer adds beyond the generic slice shape.
type BillingRunsSlice = StateSlice<BillingRun> & { isEnabled: boolean };

// Enables billing runs when `shouldEnable` is true, matching what the
// Billing tab normally does. Some Billing Document UI is reachable
// without visiting that tab, where billing runs would otherwise stay
// disabled.
export function useEnsureBillingRunLoaded(shouldEnable: boolean): void {
  const dispatch = useDispatch();
  const isBillingRunEnabled = useSelector<State, boolean>(
    state => (state.billingRuns as BillingRunsSlice).isEnabled,
  );

  useEffect(() => {
    if (shouldEnable && !isBillingRunEnabled) {
      dispatch(BillingRunAction.enable(getLivestockSaleId()));
    }
  }, [shouldEnable, isBillingRunEnabled, dispatch]);
}
